/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.3
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

const progressDoughnutChartData = {
  labels: ["Done", "In progress"],
  datasets: {
    label: "Projects",
    backgroundColors: ["info", "secondary"],
    data: [75, 25],
  },
};

export default progressDoughnutChartData;
